import React, { Component } from 'react';
import { BASE_URL } from "../../../config";
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { getDisplayDate } from '../../../libs/date';
import ImageSlider from '../../ImageSlider';

@observer
class ImagePopup extends Component {

  @observable expanded = false;
  @observable selectedImage = null;

  render() {
    const { station } = this.props;
    
    let image = this.expanded && this.selectedImage ? this.selectedImage : station.image[0]
    
    return (
      <div id={`station_marker-${station.id}-popup`} key={`station_marker-${station.id}-popup`}>
        <div className='flex flex-row space-between'>
          <a href={`/#/station/${station.id}/images`} style={{ fontSize: '15px', fontWeight: 'bold', marginLeft: '4px' }}>{station.name}</a>
          <i className={`fa fa-${this.expanded ? 'compress' : 'expand'} marker-popup-icon`} onClick={() => this.expanded = !this.expanded} />
        </div>
        <div className='flex flex-row space-between' style={{marginRight: '5px'}}>
          <div>{getDisplayDate(image.date_taken)}</div>
          <div>{image.album_code}</div>
        </div>
        {this.expanded ?
          <ImageSlider baseUrl={`${BASE_URL}/idaq-files`} images={station.image} filterKey={'date_taken'} onChangeImage={(image) => this.selectedImage = image} noSlider={true} play={true}  height={'450'} width={'600px'}/> :
          <div style={{
            minHeight: '150px',
            minWidth: '200px',
            height: '100%', width: '100%',
            backgroundImage: `url(${BASE_URL}/idaq-files/${image.source})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            // resize: 'both',
            // overflow: 'auto'
          }} />}
      </div>
    );
  }
}



export default ImagePopup;


// WEBPACK FOOTER //
// ./src/components/Images/pages/ImagePopup.js